import React, { Component } from 'react';

import './Associados.scss';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import renderHTML from 'react-render-html';
import CountUp, {startAnimation} from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

// import OwlCarousel from 'react-owl-carousel2';
// import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
// import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views,
	distribuicoes,
	associados_content
} from '../../settings';

import {
	DelayLink,
	Compromisso,
	HoveredImage
} from '../../components/';

import {
    PositionCalculator
} from '../../utils/';

class Associados extends Component {

	constructor(props) {
		super(props);

		this.barsRef = React.createRef();

        this.images = images;

        this.associados_content = associados_content;

        this.calculator = PositionCalculator;

        this.state = {
            width: window.innerWidth,
        	shadowOpacity: 'shown',
        	compromissosStep: null,
        	compromisso0: '',
        	compromisso1: '',
        	compromisso2: '',
        	compromisso3: '',
        	barsClass: '',
        	// mapsClass: (window.innerWidth <= 769) ? 'all' : 'norte',
        	mapsClass: 'all',
        	mapYearActive2016: '',
        	mapYearActive2017: '',
        	mapYearActive2018: 'maps__timeline__year--active',
        	mapNumberNorte: 2,
        	mapNumberNordeste: 4,
        	mapNumberCentroOeste: 4,
        	mapNumberSudeste: 240,
        	mapNumberSul: 10,
        	mapNumberTotal: 260,

        	countDelay: 2,

            tabsActive: null
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeCompromissos = this.changeCompromissos.bind(this);
        this.inView = this.inView.bind(this);
        this.barsReveal = this.barsReveal.bind(this);
        this.changeMaps = this.changeMaps.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.scrollToMyRef = this.scrollToMyRef.bind(this);
	    this.changeTabs = this.changeTabs.bind(this);

	    this.distribuicoes = distribuicoes;
	    this.distribuicoesMaxTotal;

	    this.myCountUp1;

        this.myRef = React.createRef();
	}

    scrollToMyRef = () => {
    	let top = parseInt(this.myRef.current.offsetTop);

    	if (document.documentMode || /Edge/.test(navigator.userAgent)) {
		    console.log('Hello Microsoft User!');
    		window.scrollTo( 0, top );
		} else {
		    console.log('Hello Other Browser User!');
    		window.scrollTo({ top: top, behavior: 'smooth', })
		}
    }

	onVisibilityChange(isVisible) {
	    if (isVisible) {
			startAnimation(this.myCountUp1);
	    }
	}

    changeTabs(i) {
    	console.log(i);
    	const { tabsActive } = this.state;
    	this.setState({
    		tabsActive: (tabsActive == i) ? null : i
    	});
    }
    
    inView(el, offset = 0) {
        if (el != undefined) {
            const top = el.getBoundingClientRect().top;
            return (top + offset) >= 0 && ((top - offset) <= (window.innerHeight - 100));
        } else {
            return false;
        }
    }

    barsReveal() {
        if (this.inView(this.barsRef)) {
			setTimeout(function() {
            	this.setState({ barsClass: 'reveal'});
			}.bind(this), 700);
        }
    }

    changeMaps(newState) {
    	this.scrollToMyRef();
    	this.setState({ mapsClass : newState });
    }

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    changeCompromissos(num) {
    	if (this.state.compromissosStep != num) {
    		this.setState({ compromissosStep : num });

    		this.setState({
    			compromisso0 : '',
    			compromisso1 : '',
    			compromisso2 : '',
    			compromisso3 : ''
    		});

    		switch (num) {
    			case 0:
    				this.setState({ compromisso0 : 'active' });
    				break;
    			case 1:
    				this.setState({ compromisso1 : 'active' });
    				break;
    			case 2:
    				this.setState({ compromisso2 : 'active' });
    				break;
    			case 3:
    				this.setState({ compromisso3 : 'active' });
    				break;
    			default:
    				this.setState({ compromisso0 : 'active' });
    				break;
    		}
    	}
    }

    changeYear(year) {
    	this.scrollToMyRef();

		switch (year) {
			case '2016':
				this.setState({
		        	mapYearActive2016: 'maps__timeline__year--active',
		        	mapYearActive2017: '',
		        	mapYearActive2018: '',
		        	
		        	mapNumberNorte: 2,
		        	mapNumberNordeste: 5,
		        	mapNumberCentroOeste: 4,
		        	mapNumberSudeste: 249,
		        	mapNumberSul: 11,
        			mapNumberTotal: 271
				});
				break;

			case '2017':
				this.setState({
		        	mapYearActive2016: '',
		        	mapYearActive2017: 'maps__timeline__year--active',
		        	mapYearActive2018: '',
		        	
		        	mapNumberNorte: 2,
		        	mapNumberNordeste: 4,
		        	mapNumberCentroOeste: 4,
		        	mapNumberSudeste: 247,
		        	mapNumberSul: 10,
        			mapNumberTotal: 267
				});
				break;

			case '2018':
				this.setState({
		        	mapYearActive2016: '',
		        	mapYearActive2017: '',
		        	mapYearActive2018: 'maps__timeline__year--active',

		        	mapNumberNorte: 2,
		        	mapNumberNordeste: 4,
		        	mapNumberCentroOeste: 4,
		        	mapNumberSudeste: 240,
		        	mapNumberSul: 10,
        			mapNumberTotal: 260
				});
				break;
		}
    }

    componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('03 Associados');
    }

	componentDidMount() {
    	this.barsRef = document.querySelector('.percent_bars');
    	this.barsReveal();

    	this.changeCompromissos(0);

        window.addEventListener('scroll', this.barsReveal);

		// setTimeout(function() {
  //       	this.setState({ countDelay: 1});
		// }.bind(this), 5000);
    }

    componentWillUnount() {
        window.removeEventListener('scroll', this.barsReveal);
    }

	render() {
        const { width, tabsActive } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'associados'
		];

		var percentBarsClassList = [
		 	'percent_bars',
		 	this.state.barsClass
		];

		var mapsClassList = [
		 	'maps',
		 	'maps--' + this.state.mapsClass
		];
		

		var distribuicaoLabels = [];

		for (let i = 0; i < this.distribuicoes.labels.length; i++) {
			distribuicaoLabels.push(
				<li key={ i }>
					<svg viewBox="0 0 16 16" width="100%" height="100%">
						<circle cx="8" cy="8" r="6.215" fill={ this.distribuicoes.labels[i].color }></circle>
					</svg>
				 	{ this.distribuicoes.labels[i].name }
				</li>
			);
		}

		this.distribuicoesMaxTotal = Math.max.apply(Math, this.distribuicoes.years.map(function(o) { return o.total; }));

		var distribuicaoBars = [];

		for (let i = 0; i < this.distribuicoes.years.length; i++) {

			let numbers = [];
			for (let u = 0; u < this.distribuicoes.years[i].numbers.length; u++) {
				let numberWidth = this.calculator.per(this.distribuicoes.years[i].numbers[u].value, this.distribuicoes.years[i].total);
				let numberStyle = {};

				if (isMobile) {
					numberStyle.height = numberWidth+'%';
				} else {
					numberStyle.width = numberWidth+'%';
				}

				let numberBgStyle = {
					backgroundColor: this.distribuicoes.years[i].numbers[u].color
				};
				numbers.push(
					<div key={ u } className="bar__content__values__value" style={ numberStyle } alt={ this.distribuicoes.years[i].numbers[u].name }>
						<div className="background" style={ numberBgStyle }></div>
						<span>{ this.distribuicoes.years[i].numbers[u].value }</span>
					</div>
				);
			}


			let barContentWidth = this.calculator.per(this.distribuicoes.years[i].total, this.distribuicoesMaxTotal);
			let barContentStyles = {};

			if (isMobile) {
				barContentStyles.height = barContentWidth+'%';
			} else {
				barContentStyles.width = barContentWidth+'%';
			}

			distribuicaoBars.push(
				<div key={ i } className="bar">
					<div className="bar__year">{ this.distribuicoes.years[i].year }</div>

					<div className="bar__content" style={ barContentStyles }>
						<div className="bar__content__values">
							{ numbers }
						</div>
					</div>

					<div className="bar__total">{ this.distribuicoes.years[i].total }</div>
				</div>
			);
		}



		// Icon Columns - Razão Existir
		const options = {
		    items: 1,
		    nav: true,
		    bullets: true,
		    rewind: true
		};

		const iconsHtml = [];
		for (let i = 0; i < this.associados_content.razao_existir.length; i++) {
			iconsHtml.push(
				<div key={i} className="icon_columns__column">
					<div className="icon">
						<img src={ this.associados_content.razao_existir[i].image } />
					</div>
					<div className="content">
		    			<h4 className="title">{ renderHTML(this.associados_content.razao_existir[i].title) }</h4>
		    			<p className="text">{ renderHTML(this.associados_content.razao_existir[i].text) }</p>
					</div>
				</div>
			);
		}

		var outputIconsHtml;
		if (isMobile) {
			outputIconsHtml = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
								    { iconsHtml }
								</Carousel>;
		} else {
			outputIconsHtml = iconsHtml;
		}



		// Highlights 1
		var highlightFundoHtml = [];
		highlightFundoHtml.push(
			<div key="0" className="highlight_numbers__number">
    			<h4 className="first_text">R$ 
				<VisibilitySensor
	            onChange={this.onVisibilityChange}
	            delayedCall // Prevents react apps triggering elements as visible before styles are loaded
	        	>
					<CountUp
						start={0}
						end={4.6}
						delay={0}
	                    decimals={1}
	                    decimal="," 
	                    ref={countUp => { this.myCountUp1 = countUp; }}
	                    />
				</VisibilitySensor>
				</h4>
				{/*<CountUp 
                delay={this.state.countDelay}
                end={ 4.6 }
                decimals={1}
                decimal="," />*/}
				<h5 className="second_text">trilhões</h5>
				<h5 className="third_text">em patrimônio<br />líquido</h5>

			</div>
		);
		highlightFundoHtml.push(
			<div key="1" className="highlight_numbers__number">
    			<h4 className="first_text">
	                <CountUp 
	                    delay={this.state.countDelay}
	                    end={ 17049 }
	                    separator="."
	                    decimals={0} />
    			</h4>
				<h5 className="third_text">fundos<br />registrados</h5>
			</div>
		);
		highlightFundoHtml.push(
			<div key="2" className="highlight_numbers__number">
    			<h4 className="first_text">
    				<CountUp 
	                    delay={this.state.countDelay}
	                    end={ 84.7 }
	                    decimals={1}
	                    decimal="," />
	            </h4>
    			<h5 className="second_text">bilhões</h5>
    			<h5 className="third_text">de captação líquida<br />no mercado doméstico</h5>
			</div>
		);

		var outputHighlightFundo;
		if (isMobile) {
			outputHighlightFundo = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
								    	{ highlightFundoHtml }
									</Carousel>;
		} else {
			outputHighlightFundo = highlightFundoHtml;
		}


		// Highlights 2
		var highlightMercadoHtml = [];
		highlightMercadoHtml.push(
			<div key="0" className="highlight_numbers__number">
    			<h4 className="first_text">
    				R$ <CountUp 
	                    delay={this.state.countDelay}
	                    end={ 223.7 }
	                    decimals={1}
	                    decimal="," />
	            </h4>
    			<h5 className="second_text">bilhões</h5>
    			<h5 className="third_text">em ofertas de valores<br />mobiliários</h5>
			</div>
		);
		highlightMercadoHtml.push(
			<div key="1" className="highlight_numbers__number">
    			<h4 className="first_text">
    				R$ <CountUp 
	                    delay={this.state.countDelay}
	                    end={ 11.3 }
	                    decimals={1}
	                    decimal="," />
	            </h4>
    			<h5 className="second_text">bilhões</h5>
    			<h5 className="third_text">em ofertas públicas<br />de renda variável</h5>
			</div>
		);
		highlightMercadoHtml.push(
			<div key="2" className="highlight_numbers__number">
    			<h4 className="first_text">
    				R$ <CountUp 
	                    delay={this.state.countDelay}
	                    end={ 199.6 }
	                    decimals={1}
	                    decimal="," />
	            </h4>
    			<h5 className="second_text">bilhões</h5>
    			<h5 className="third_text">em ofertas<br />de renda fixa</h5>
			</div>
		);
		highlightMercadoHtml.push(
			<div key="3" className="highlight_numbers__number">
    			<h4 className="first_text">
    				R$ <CountUp 
	                    delay={this.state.countDelay}
	                    end={ 12.8 }
	                    decimals={1}
	                    decimal="," />
	            </h4>
    			<h5 className="second_text">bilhões</h5>
    			<h5 className="third_text">em ofertas de<br />produtos híbridos</h5>
			</div>
		);

		var outputHighlightMercado;
		if (isMobile) {
			outputHighlightMercado = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
										    { highlightMercadoHtml }
										</Carousel>;
		} else {
			outputHighlightMercado = highlightMercadoHtml;
		}


		// Highlights 3
		var highlightDistribuicaoHtml = [];
		highlightDistribuicaoHtml.push(
			<div key="0" className="highlight_numbers__number">
    			<h4 className="first_text">
    				R$ <CountUp 
	                    delay={this.state.countDelay}
	                    end={ 1.8 }
	                    decimals={1}
	                    decimal="," />
	            </h4>
    			<h5 className="second_text">trilhão</h5>
    			<h5 className="third_text">de ativos geridos<br />no varejo</h5>
			</div>
		);
		highlightDistribuicaoHtml.push(
			<div key="1" className="highlight_numbers__number">
    			<h4 className="first_text">
    				R$ <CountUp 
	                    delay={this.state.countDelay}
	                    end={ 1.1 }
	                    decimals={1}
	                    decimal="," />
	            </h4>
    			<h5 className="second_text">trilhão</h5>
    			<h5 className="third_text">sob gestão do<br />private banking</h5>
			</div>
		);

		var outputHighlightDistribuicao;
		if (isMobile) {
			outputHighlightDistribuicao = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
											    { highlightDistribuicaoHtml }
											</Carousel>;
		} else {
			outputHighlightDistribuicao = highlightDistribuicaoHtml;
		}


		var accordionContent = [];
		for (let i = 0; i < this.associados_content.associados_list.length; i++) {
			let contentItems = [];

			for (let u = 0; u < this.associados_content.associados_list[i].items.length; u++) {
				contentItems.push(
					<li key={u}>{ this.associados_content.associados_list[i].items[u] }</li>
				);
			}

			let letter = this.associados_content.associados_list[i].letter;
			accordionContent.push(
		        <AccordionItem
		        	key={i}
		        	className={ (tabsActive == letter || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
		            <AccordionItemTitle>
		                <h3 onClick={this.changeTabs.bind(null, letter)}>{ letter }</h3>
		            </AccordionItemTitle>
		            <AccordionItemBody>
    					<ul>
    						{ contentItems }
    					</ul>
		            </AccordionItemBody>
		        </AccordionItem>
			);
		}


		var mapYearClass2016 = [
			'maps__timeline__year',
			'maps__timeline__year--2016',
			this.state.mapYearActive2016
		];

		var mapYearClass2017 = [
			'maps__timeline__year',
			'maps__timeline__year--2017',
			this.state.mapYearActive2017
		];

		var mapYearClass2018 = [
			'maps__timeline__year',
			'maps__timeline__year--2018',
			this.state.mapYearActive2018
		];


        return (

			<div className="views">
			
				<Helmet>
	                <title>03 Associados - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>03</span> Associados</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Associados</p>
		        			</div>
		        		</header>

		        		<div className="views__content first_view row">
			        		<div className="container">
			        			
				        		<div className="column column--half">
				        			<Fade bottom>
					        			<p className="first_paragraph">
					        				Entre gestoras, corretoras, distribuidoras, bancos múltiplos, comerciais e de investimento, encerramos 2018 com
										</p>
					        			<p className="custom_number">
					        				<span className="number">260</span>
					        				<span className="text">associados.</span>
										</p>
					        			<p className="gri_p">
					        				<span className="gri_label"><text>GRI 102-6, 102-7</text></span>
					        			</p>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--padding column--no-padding-mobile text-center">
				        			<Fade bottom>
					        			<HoveredImage
					        				image1={ this.images.associados_img1 }
					        				image2={ this.images.associados_img1_hover } />
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content second_view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<p className="first_paragraph">
					        				É um retrato, dentro de casa, da pluralidade dos mercados financeiro e de capitais.<br />
					        				No fim de 2018, esses mercados possuíam: 
										</p>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content titled_view yellow_view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<h3 className="titled_view__title">Fundos de investimento</h3>
					        			<div className="highlight_numbers row">
					        				{ outputHighlightFundo }
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>


		        		<div className="views__content titled_view light_green_view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<h3 className="titled_view__title">Mercado de capitais</h3>

					        			<div className="highlight_numbers row">
						        			{ outputHighlightMercado }
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>


		        		<div className="views__content titled_view green_view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<h3 className="titled_view__title">Distribuição</h3>

					        			<div className="highlight_numbers row">
					        				{ outputHighlightDistribuicao }
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>


		        		<div className="views__content titled_view green_view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<h3 className="titled_view__title titled_view__title--no-line">Perfil dos associados</h3>
				        				<h2 className="section_title">Distribuição por segmentos<br />de mercado</h2>

					        			<div className={ percentBarsClassList.join(' ') } ref={ this.barsRef }>
						        			<div className="percent_bars__bars">
							        			{ distribuicaoBars }
						        			</div>

						        			<div className="percent_bars__labels">
							        			<ul>
							        				{ distribuicaoLabels }
							        			</ul>
						        			</div>
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>


		        		<div className="views__content titled_view regions_view row" ref={ this.myRef }>
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<h3 className="titled_view__title titled_view__title--no-line">Perfil dos associados</h3>
				        				<h2 className="section_title">Distribuição<br />geográfica</h2>

				        				<div className="maps__total">
				        					<div className="text">total</div>
				        					<div className="number">{ this.state.mapNumberTotal }</div>
				        				</div>

				        				<div className="maps__list">
				        					<ul>
				        						<li className={(this.state.mapsClass == 'all') ? 'active' : ''} onClick={ this.changeMaps.bind(null, 'all') }><span>Todos</span></li>
				        						<li className={(this.state.mapsClass == 'norte') ? 'active' : ''} onClick={ this.changeMaps.bind(null, 'norte') }><span>Norte</span></li>
				        						<li className={(this.state.mapsClass == 'nordeste') ? 'active' : ''} onClick={ this.changeMaps.bind(null, 'nordeste') }><span>Nordeste</span></li>
				        						<li className={(this.state.mapsClass == 'centrooeste') ? 'active' : ''} onClick={ this.changeMaps.bind(null, 'centrooeste') }><span>Centro-Oeste</span></li>
				        						<li className={(this.state.mapsClass == 'sudeste') ? 'active' : ''} onClick={ this.changeMaps.bind(null, 'sudeste') }><span>Sudeste</span></li>
				        						<li className={(this.state.mapsClass == 'sul') ? 'active' : ''} onClick={ this.changeMaps.bind(null, 'sul') }><span>Sul</span></li>
				        					</ul>
				        				</div>

					        			<div className={ mapsClassList.join(' ') }>
				        					<img src={ this.images.associados_map_base } />

				        					<div className="maps__number maps__number--norte">{ this.state.mapNumberNorte }</div>
				        					<div className="maps__number maps__number--nordeste">{ this.state.mapNumberNordeste }</div>
				        					<div className="maps__number maps__number--centrooeste">{ this.state.mapNumberCentroOeste }</div>
				        					<div className="maps__number maps__number--sudeste">{ this.state.mapNumberSudeste }</div>
				        					<div className="maps__number maps__number--sul">{ this.state.mapNumberSul }</div>

				        					<div className="maps__item maps__item--norte"><img src={ this.images.associados_map_1 } /></div>
				        					<div className="maps__item maps__item--nordeste"><img src={ this.images.associados_map_2 } /></div>
				        					<div className="maps__item maps__item--centrooeste"><img src={ this.images.associados_map_3 } /></div>
				        					<div className="maps__item maps__item--sudeste"><img src={ this.images.associados_map_4 } /></div>
				        					<div className="maps__item maps__item--sul"><img src={ this.images.associados_map_5 } /></div>
				        				</div>

				        				<div className="maps__timeline">
				        					<div className={ mapYearClass2016.join(' ') } onClick={ this.changeYear.bind(null, '2016') }>2016</div>
				        					<div className={ mapYearClass2017.join(' ') } onClick={ this.changeYear.bind(null, '2017') }>2017</div>
				        					<div className={ mapYearClass2018.join(' ') } onClick={ this.changeYear.bind(null, '2018') }>2018</div>
				        				</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>


		        		<div className="views__content titled_view disclaimer_view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
				        				<h2 className="section_title">Os associados são nossa razão de existir.</h2>
					        			<h3 className="titled_view__title titled_view__title--no-line">Para uma comunicação mais ágil e pontual com eles, são usadas várias ferramentas e canais de relacionamento como:</h3>

					        			<div className="icon_columns row">
						        			{ outputIconsHtml }
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content titled_view associados_list row">
			        		<div className="container">
			        			
				        		<div className="column column--half column--padding-right column--content">
				        			<Fade bottom>
				        				<h2 className="section_title">Lista de<br />associados</h2>
					        			<h3 className="titled_view__title titled_view__title--no-line">Em 31 de dezembro de 2018</h3>

					        			<HoveredImage
					        				image1={ this.images.associados_lista }
					        				image2={ this.images.associados_lista_hover } />

				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--padding column--list">
				        			{/*<Accordion onChange={ this.changeTabs }>*/}
				        			<Accordion>
								        { accordionContent }
								    </Accordion>
				        		</div>

			        		</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { Associados };
